import { PartialType, PickType } from '@nestjs/swagger';
import { SpSubdivisionNameUpdatableInterface } from '../interfaces/sp-subdivision-name-updatable.interface';
import { SpSubdivisionNameDto } from './sp-subdivision-name.dto';

export class SpSubdivisionNameUpdateDto
  extends PartialType(PickType(SpSubdivisionNameDto, ['active']))
  implements SpSubdivisionNameUpdatableInterface {}
